import { Fragment, useState } from 'react';
import { Sidebar, TableSortPropertyState } from '@rr/ui';
import { useAuth } from '@rr/auth-context';
import { useGetScopedStudentsQuery } from 'types/graphql';

const LIMIT = 20;

export const StudentList = () => {
  const [offset, setOffset] = useState(0);
  const [orderBy, setOrderBy] = useState<TableSortPropertyState>({
    first_name: 'asc',
  });

  const { user } = useAuth();

  const { error, data } = useGetScopedStudentsQuery({
    variables: {
      scopeId: (user && user.uid) || '',
      offset,
      limit: LIMIT,
      order_by: { ...orderBy },
    },
  });

  if (error) {
    console.error(error);
    return <div>Error! Please check the console.</div>;
  }

  const updateOffset = (number: number) => setOffset(number);

  const students = data?.students || [];

  return (
    <Fragment>
      <Sidebar.Header title="Students" />
      <Sidebar.Content>
        {students.map((student) => {
          return (
            <Sidebar.Item key={student.id} to={`/students/${student.id}`}>
              <div>{student.gdpr_name}</div>
              <small>{student.student_locations[0].location.name || '-'}</small>
            </Sidebar.Item>
          );
        })}
      </Sidebar.Content>
      <Sidebar.Footer
        updateOffset={updateOffset}
        offset={offset}
        limit={LIMIT}
        count={data?.students_aggregate.aggregate?.count}
      />
    </Fragment>
  );
};
